module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-32.5384d0e7.jpg";